import { isProduction } from "@/helpers/global/env.func";

export const config = {
  company: 'basic',
  market: 'hk',
  locale: 'hk',
  version: 'itrade7.5-v7.0.4',
  company_title: 'company_title',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  routerPrefix: isProduction() ? (window.config?.webPath && `/${window.config.webPath}` || '') : '',
  thirdPartyLink: '',
  checkTabs: true,
  apis: {
    winvestorApi: true,
    mdsApi: true,
  },
  actions:{
    trading:{
      market_label:true,
    },
  },
  layouts: {
    fullLayout: {
      logoImgName: 'logo_dark.png',
    },
    mainLayout: {
      logoImgName: 'logo_dark.png',
    }
  },
  pages: {
    login: {
      ctrl: { securityTips: false }
    },
    trade: {
      rewrite: false,
      ctrl:{ 
        searchDropdown: true
      },
      usePrePost: false,
      orderEnquiry: {
        autoRefresh: {
          refreshTime: isProduction() ? (window.config?.companyOptions?.trading?.autoRefreshOrderEnquiry) : 5000,
          refreshSession: isProduction() ? (window.config?.companyOptions?.trading?.refreshSession) : false,
          checkSessionTime: isProduction() ? (window.config?.companyOptions?.trading?.autoCheckSession) : 300000
        }
      }
    },
    market: {
      init: { isOpenChart: true },
      ctrl: { orderDialog : true }
    },
	  fundManagement: {
      fundTransfer:{
        queryCurrencyConversion:true
      },
      fundTransferEnquiry:{
        foreignExchangeEnquiry:true
      }
    },
    ipo:{
      margin:{
        disableCancel:true
      }
    }
  },
  constants: {
    winVest: {
      winvestorDeviceID: 'itrade7.5-web-ttl',
      winvestorConsumerId: 'winvestor_ttl_broker',
      winvestorConsumerSecret: '$2y$10$i2c7LGyreYVUYjvQg1huUupnLufpzTugDyelyaowsZGe36j8N5KFi',
    },
    apiEnv: {
      itradeAPI: location.origin,
      itradePath: '',
    
      MDSStreamingAPI: '',
      MDSSnapshotAPI: '',
      MDSOthersAPI: '',
      MDSPath: '',
      MDSEntityKey: 'EIF',
      MDSSuperkey: 'eifhk2txtech1keyencrypt20key0729',
    
      winvestorAPI: location.origin,
      winvestorPath: 'ttl/api'
    }
  }
}